import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { leagueService } from '@/services/league';

export function useLeagueList() {
    const { list, total, fetchList } = useBaseListView({ request: leagueService.item.list });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: leagueService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
